// extracted by mini-css-extract-plugin
module.exports = {"container":"SterilizerProgramTable_container__2ihS6","tableContainer":"SterilizerProgramTable_tableContainer__3rUUs"};